import * as React from "react"

/** Shared mobile breakpoint — matches Tailwind `md` (768px). */
export const MOBILE_BREAKPOINT_PX = 768

function isNarrowViewportWidth(width: number): boolean {
  return width < MOBILE_BREAKPOINT_PX
}

/**
 * True when viewport is below the mobile breakpoint (< 768px).
 *
 * SSR and the first client render both return `false` so markup matches
 * (avoids hydration mismatches from `typeof window` branching). The real
 * viewport is applied in `useEffect` after mount.
 */
export function useIsNarrowViewport(): boolean {
  const [narrow, setNarrow] = React.useState(false)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`)
    const update = () => setNarrow(mql.matches)
    mql.addEventListener("change", update)
    update()
    return () => mql.removeEventListener("change", update)
  }, [])

  return narrow
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`)
    const onChange = () => {
      setIsMobile(isNarrowViewportWidth(window.innerWidth))
    }
    mql.addEventListener("change", onChange)
    onChange()
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
